import { Typography } from '@mui/material'
import { forwardRef } from 'react'
import { FieldWrapper } from '../FieldWrapper'

const MyTableCell = forwardRef((props, ref) => {
  const {
    editMode,
    component,
    value,
    field,
    errors,
    data,
    setDataParent,
    onValueChange,
    onDateChange,
    editRow,
    validate,
    defaultValueFunction,
    onRowDataChange,
    cellKey
  } = props

  const renderField = (mode = 'view') => (
    <FieldWrapper
      key={cellKey}
      ref={ref}
      field={field}
      errors={errors}
      data={data}
      isTable={true}
      mode={mode}
      setDataParent={setDataParent}
      onValueChange={onValueChange}
      onDateChange={onDateChange}
      validate={validate}
      editRow={editRow}
      setValue={defaultValueFunction}
      onRowDataChange={onRowDataChange}
    />
  )

  if (!editMode || field === undefined) {
    if (component) return component(value)
    if (field?.type === 'checkbox') return renderField('view')

    const isMultiline = typeof value === 'string' && value.includes('\n')

    return (
      <Typography
        sx={
          isMultiline
            ? { whiteSpace: 'pre-line', wordBreak: 'break-word', marginTop: '10px' }
            : {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                WebkitLineClamp: '1',
                WebkitBoxOrient: 'vertical',
                whiteSpace: 'nowrap',
                verticalAlign: 'top',
                marginTop: '10px'
              }
        }
      >
        {value ?? '-'}
      </Typography>
    )
  }

  if (field?.render) {
    return field.render(editRow, onRowDataChange)
  }

  return renderField('edit')
})

export default MyTableCell
